import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentJointDocumentVerificationDataV2,
  type EnrollmentJointDocumentVerificationSubmitOutputV2,
} from '../../../../../models'
import { DocumentVerificationStatus } from '../../../../../models/enrollment/enrollment'

export const getEnrollmentJointDocumentVerificationDataMockV2: EnrollmentJointDocumentVerificationDataV2 = {
  errors: [],
  isError: false,
  activePerson: {
    applicationId: '123',
    path: '/enrollment/joint/document-verification',
    progress: 50,
    name: {
      firstName: 'John',
      lastName: 'Doe',
    },
    documentVerificationId: 'doc-verify-123',
    documentVerificationStatus: 'pending',
  },
}

export const submitEnrollmentJointDocumentVerificationDataMockV2: EnrollmentJointDocumentVerificationSubmitOutputV2 = {
  errors: [],
  isError: false,
  activePerson: {
    path: '/enrollment/joint/next-page-here',
    documentVerificationId: 'doc-verify-456',
    documentVerificationStatus: 'submitted',
  },
}

let callCount = 0

export const submitEnrollmentJointSDocVerificationCheckStatusDataMockV2 =
  (): EnrollmentJointDocumentVerificationSubmitOutputV2 => {
    callCount++

    return {
      errors: [],
      isError: false,
      activePerson: {
        path: '/enrollment/hycs/document-verification-complete',
        documentVerificationStatus:
          callCount >= 3 ? DocumentVerificationStatus.Complete : DocumentVerificationStatus.Pending,
      },
    }
  }

export const mockGetEnrollmentJointDocumentVerificationDataV2 = graphql.mutation(
  'getEnrollmentJointDocumentVerificationData',
  () => {
    return HttpResponse.json({
      data: {
        submitJointEnrollment: getEnrollmentJointDocumentVerificationDataMockV2,
      },
    })
  },
)

export const mockSubmitEnrollmentJointDocumentVerificationDataV2 = graphql.mutation(
  'submitEnrollmentJointDocumentVerificationData',
  () => {
    return HttpResponse.json({
      data: {
        submitJointEnrollment: submitEnrollmentJointDocumentVerificationDataMockV2,
      },
    })
  },
)

export const mockSubmitEnrollmentJointDocVerificationCheckStatusDataV2 = graphql.mutation(
  'submitEnrollmentJointDocVerificationCheckStatusData',
  () => {
    return HttpResponse.json({
      data: { submitJointEnrollment: submitEnrollmentJointSDocVerificationCheckStatusDataMockV2() },
    })
  },
)

export const mockEnrollmentJointDocumentVerificationV2 = [
  mockGetEnrollmentJointDocumentVerificationDataV2,
  mockSubmitEnrollmentJointDocumentVerificationDataV2,
  mockSubmitEnrollmentJointDocVerificationCheckStatusDataV2,
]
